export default {
  leverText: "Salut et bienvenue !\n" +
  "Je suis Clank et je vais t’accompagner dans la visite de ce site.\n\n" +
  "Avant de tirer le levier pour entrer, retiens bien ces 3 intéractions :\n\n" +
  "🟢 Vert : je parle.\n" +
  "🟠 Orange : tu peux cliquer.\n" +
  "🔴 Rouge : tu peux cliquer, et je te parlerai en même temps.\n\n" +
  "Amuse-toi bien !",
  nav: {
    home: "Accueil",
    projects: "Projets",
    playground: "Aire de jeux",
  },
  carouselProjects: {
    scrollToExploreTheProject: "Scrollez pour explorer le projet",
  },
  projects: {
    algoForge: {
      description:
        "AlgoForge est une application web gratuite et open source de conception d'algorithmes, pensée par et pour les étudiants. Elle se distingue par sa simplicité, sa rapidité, et son respect du formalisme de l'IUT de Bayonne. Accessible depuis n'importe quel appareil, elle propose une interface dynamique, un rendu fidèle à l'export, des raccourcis pratiques, et des fonctionnalités collaboratives. Nous avons misé sur l'éco-responsabilité et la performance, guidant le choix de nos technologies et de notre approche.",
      pitch:
        "Un éditeur graphique interactif permettant de concevoir des algorithmes.",
    },
    clim6440: {
      description:
        "Clim 64-40 est le site vitrine d’un artisan climaticien, un projet que j’ai mené en deux grandes étapes. La première partie concernait le design : création du logo et élaboration d’une charte graphique complète, avec toute la réflexion autour de l’identité visuelle de l’entreprise. J’ai ensuite appliqué cette charte aussi bien sur des supports physiques (cartes de visite, flyers) que numériques, avec la conception du site web. Comme l’objectif était que l’artisan puisse modifier son site facilement et rapidement, le choix s’est porté sur un CMS, en l’occurrence WIX.",
      pitch:
        "Un site vitrine d’un artisan climaticien permettant de découvrir ses services, ses réalisations et de le contacter.",
    },
  },
  links: {
    github: "Visitez le GitHub",
    wiki: "Visitez le wiki",
    browser: "Visitez le site web",
  },
  descriptionLabel: "Description",
  technologiesLabel: "Technologies",
  musicCredit: "Musique par Lidrima",
  visitMyGithub: "Visitez mon GitHub",
  visitMyLinkedin: "Visitez mon LinkedIn",
  nameInfo: "Ouaw, ça a l’air d’être le nom de quelqu'un de super !",
} as const;
